

























import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import PointerMenu from "../general/PointerMenu.vue";
import Loading from "../general/Loading.vue";

import InvoiceInfoJson from "../../shared/InvoiceInfoJson";

export default Vue.extend({
  name: "InvoiceInfoDetails",
  components: {
    PointerMenu,
    Loading,
  },
  props: {
    restClient: RestClient,
    data: Array as PropType<InvoiceInfoJson[] | null>,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      details: null as InvoiceInfoJson[] | null,
      loadingGeneral: false as boolean,
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    init() {
      this.details = this.data;
    },
  },

  watch: {},

  computed: {},
});
